import React, { useCallback } from "react";
import CustomTable, { Column } from "../../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { useManageClientContext } from "../../../context/ManageClientContex";
import { Project } from "../../../model/clientmodel";
import { toast } from "react-toastify";
// import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { getCookieData, setCookieData } from "../../../helper/api";

const ClientProject: React.FC<{ clientID: number; userID: number }> = ({ clientID, userID }) => {
  const navigate = useNavigate();
  const clientProjectStatus = getCookieData('clientProject');
  const { setProjectFormType, clientDetails, getClientDetails } = useManageClientContext();
  const [statusValueData, setStateValueData] = React.useState<string>(clientProjectStatus ? clientProjectStatus : "0");
  const [searchName, setSearchName] = React.useState<string>("");

  const columns: Column<Project>[] = [
    { header: "Client Name", key: "name", enableLink: true, path: "/client/updateclientproject" },
    {
      header: "Project Name",
      key: "project_code",
      enableLink: false,
      path: "",
    },
    {
      header: "Start Date",
      key: "start_ts",
      enableLink: false,
      path: "",
    },
    { header: "End Date", key: "end_ts", enableLink: false, path: "" },
    { header: "Project Manager", key: "manager", enableLink: false, path: "" },
    { header: "Department Name", key: "department", enableLink: false, path: "" },
  ];

  const getDetails = useCallback((status: string) => {
    getClientDetails({
      user_id: userID,
      client_id: clientID,
      status: Number(status),
    });
  }, []);

  // const refreshTable = () => {
  //   setStateValueData("0");
  //   setSearchName("");
  //   getDetails("0");
  // };

  const handleNavigation = (path: string | undefined, states: number) => {
    setProjectFormType("update");
    if (!states) toast.error("Some Values are missing, not valid data");
    if (states) {
      navigate(path ?? "", { state: { id: states, clientId: clientID, formtype: "update" } }); // Navigate to the specified path with state
    }
  };

  return (
    <CustomTable
      showFilter={false}
      columns={columns}
      idKeyName='id'
      data={
        clientDetails?.projects
          ? clientDetails?.projects.filter((item) =>
              item.name.toLowerCase().includes(searchName.toLowerCase()),
            )
          : []
      }
      handleNavigation={handleNavigation}
    >
      <button
        onClick={() => {
          setProjectFormType("create");
          navigate("/client/createclientproject", {
            state: { id: null, clientId: clientID, formtype: "create" },
          });
        }}
        className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-800 text-white rounded-lg focus:outline-none hover:bg-gray-600'
      >
        Add Project
      </button>
      <div className='max-w-4xl gap-x-6 gap-y-8 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 '>
        <div>
          <label
            htmlFor='Project Name'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            Search By Project Name
          </label>
          <div className='mt-2'>
            <input
              type='text'
              placeholder=''
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          </div>
        </div>
        <div>
          <label
            htmlFor='status'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-white'
          >
            Status
          </label>
          <div className='mt-2'>
            <select
              id='status'
              value={statusValueData}
              onChange={(e) => {
                setCookieData('clientProject', e.target.value)
                setStateValueData(e.target.value);
                getDetails(e.target.value);
              }}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            >
              <option value='0'>Active</option>
              <option value='1'>InActive</option>
            </select>
          </div>
        </div>
        {/* <div className='flex space-x-4'> */}
          {/* <button
            onClick={() => handleTableRefresh()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <MagnifyingGlassIcon className='h-5 w-5 text-white' />
          </button> */}
          {/* <button
            onClick={() => refreshTable()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <ArrowPathIcon className='h-5 w-5 text-white' />
          </button> */}
        {/* </div> */}
      </div>
    </CustomTable>
  );
};

export default ClientProject;
